import { ResourcePage } from "@/components/resource-page"
import { z } from "zod"
import { Shield } from "lucide-react"

const permissionSchema = z.object({
  name: z.string().min(1, "Name is required"),
  display_name: z.string().min(1, "Display name is required"),
  level: z.number().min(0, "Level must be positive"),
  permissions: z.string().optional(),
})

const permissionColumns = [
  { key: "id", type: "text", options: { label: "ID" } },
  { key: "name", type: "text", options: { label: "Name" } },
  { key: "display_name", type: "text", options: { label: "Display Name" } },
  { key: "level", type: "number", options: { label: "Level" } },
  { key: "description", type: "text", options: { label: "Description" } },
]

const permissionFormFields = [
  { name: "name", label: "Name", type: "text", placeholder: "Enter role name" },
  { name: "display_name", label: "Display Name", type: "text", placeholder: "Enter display name" },
  { name: "level", label: "Level", type: "number", placeholder: "Enter level (0-100)" },
  { name: "description", label: "Description", type: "text", placeholder: "Enter description" },
]

export default function PermissionsPage() {
  return (
    <ResourcePage
      resource="permissions/roles"
      title="Permissions"
      icon={Shield}
      columns={permissionColumns}
      formFields={permissionFormFields}
      formSchema={permissionSchema}
      searchPlaceholder="Search permissions..."
    />
  )
}
